<template>
  <div class="panel" v-click-outside="panel_close" @click="panel_toggle">
    <div v-if="is_authenticated()" class="d-flex align-items-center">
      <availability v-if="!is_mobile()" class="panel__credits" />
      <avatar />
    </div>
    <div v-else class="panel__deco">
      <div class="panel__burger">
        <vb-icon :name="'hamburger'" :color="sass('primary')" :size="23" />
      </div>
    </div>
    <panel-navigation v-show="links_open" :name="name" />
  </div>
</template>

<script>
import { get_config } from "@src/utilities"
import Avatar from '@components/atoms/avatar.vue'
import Availability from './availability.vue'
import PanelNavigation from './panel-navigation.vue'

export default {
  name: 'panel',

  components: {
    'avatar': Avatar,
    'availability': Availability,
    'panel-navigation': PanelNavigation,
  },

  props: {
    variant: {
      type: String,
      default: 'light',
    },
  },

  data() {
    return {
      name: '',
      links_open: false,
    }
  },

  computed: {
  },

  created() {
    window.addEventListener('scroll', () => {
      this.links_open = false
    })
  },

  mounted() {
    this.name = get_config('integration.displayName', '')
  },

  methods: {
    panel_close() {
      this.links_open = false
      document.body.classList.remove('menuOpen')
    },

    panel_toggle() {
      this.links_open = !this.links_open
      this.links_open ? document.body.classList.add('menuOpen') : document.body.classList.remove('menuOpen')
    },
  },
}
</script>

<style lang="scss" scoped>

  .panel {
    position: relative;

    &__credits {
      border: 1px solid $gray-300;
      padding: $grid-gutter-width / 3;
      border-radius: 50px;
      display: flex;
      align-items: center;
      background-color: $white;
      margin-right: $grid-gutter-width / 3;
      padding: 13px 15px; // Adjusted padding for better alignment
      border-color: $white;
      cursor: default;

      ::v-deep {
        .availability__credits {
          display: flex;
          align-items: center;

          & > div {
            margin-right: $grid-gutter-width / 2;
            padding-right: $grid-gutter-width / 2;
            border-right: 1px solid $gray-300;

            &:last-child {
              margin-right: 0;
              border: none;
              padding-right: 0;
            }
          }
        }
      }
    }

  }

</style>